import * as React from "react";
import "../Styles/style.css";
import MyadsNavigation from "./myads-navigation.jsx";
import UserDetails from "./userDetails.jsx";
import MyPostedAds from "./my-posted-ads.jsx";

export default function PostAd() {
  return (
    <>
      <div className="MyAds_main">
        <UserDetails />
        <div className="container-md MyAds_body">
          <div className="row pb-5">
            <div className="col-lg-2  p-0">
              <MyadsNavigation />
            </div>
            <div className="col-lg-10 ">
              <div className="ms-0 adsSection">
                <MyPostedAds />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
